import { useUpselledStore } from "@/store/upselled";

export function isOrderPageContext() {
  return window.globalConfig?.isOrderPage === true;
}

/**
 * Choice affiche pour le rendu informationnel d'une carte order page
 * (titre, qty editable, etc.) : offre parente quand le cart porte un upsell.
 */
export function displayChoiceForOrderPage(cartItem) {
  if (!cartItem?.choice) {
    return cartItem?.choice;
  }
  const upselledStore = useUpselledStore();
  const downgrade =
    typeof upselledStore?.getDowngradeChoice === "function"
      ? upselledStore.getDowngradeChoice(cartItem.choice)
      : null;
  return downgrade || cartItem.choice;
}

/**
 * Entree catalogue productDetails.choices (flag qty injecte par Magellan).
 */
export function choiceCatalogEntry(cartItem, { orderPage = false } = {}) {
  const choice = orderPage
    ? displayChoiceForOrderPage(cartItem)
    : cartItem?.choice;
  const choiceId = choice?.id ?? cartItem?.choice?.id;
  if (!choiceId || !window.productDetails?.choices?.length) {
    return choice;
  }
  const fromCatalog = window.productDetails.choices.find(
    (entry) => String(entry.id) === String(choiceId),
  );
  return fromCatalog || choice;
}

export function isCartItemQuantityEditable(
  cartItem,
  { orderPage = false } = {},
) {
  const choice = choiceCatalogEntry(cartItem, { orderPage });
  return (
    choice?.isQuantityEditable === true || choice?.isQuantityEditable === "true"
  );
}

export function validateCartItemQty(cartItem, event) {
  const value = event.target.value;

  if (isNaN(value) || value < 0) {
    cartItem.qty = 1;
    return;
  }

  cartItem.qty = Math.floor(Number(value));
}
